import {FormikProps} from 'formik';
import {ChangeEvent} from 'react';
import LikeInputOutlet from '../../../../components/IlikeIputOutlet';
import {IProductForm} from './productFormData';

interface IProps {
  form: FormikProps<IProductForm>;
}

const ProducingCompany = ({form}: IProps) => {
  return (
    <section>
      <p className="mb-2 color-gray-1 text-md">شرکت تولیدکننده</p>

      <LikeInputOutlet
        name="producingCompany"
        label=""
        value={form?.values.producingCompany || ''}
        placeholder="شرکت تولیدکننده را وارد کنید"
        autoComplete="off"
        type="text"
        touched={!!form?.values.producingCompany}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          form.setFieldValue('producingCompany', e.target.value);
        }}
      />
    </section>
  );
};

export default ProducingCompany;
